var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2188 1.95898V6.99023C12.2188 7.56211 12.4459 8.11056 12.8503 8.51493C13.2547 8.91931 13.8031 9.14648 14.375 9.14648H19.4062V19.9277C19.4062 20.4996 19.1791 21.0481 18.7747 21.4524C18.3703 21.8568 17.8219 22.084 17.25 22.084H5.75C5.17813 22.084 4.62968 21.8568 4.2253 21.4524C3.82093 21.0481 3.59375 20.4996 3.59375 19.9277V4.11523C3.59375 3.54336 3.82093 2.99491 4.2253 2.59054C4.62968 2.18616 5.17813 1.95898 5.75 1.95898H12.2188ZM13.6562 2.04308V6.99023C13.6562 7.18086 13.732 7.36368 13.8668 7.49847C14.0016 7.63326 14.1844 7.70898 14.375 7.70898H19.3222C19.2213 7.3578 19.0328 7.03801 18.7745 6.77964L14.5856 2.59148C14.3273 2.33287 14.0075 2.14416 13.6562 2.04308Z",
    fill: "#9D9D9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.ce39225b.svg";
export { ForwardRef as ReactComponent };